import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromInputs from './reducers';

export const selectInputsState = createFeatureSelector<fromInputs.State>(fromInputs.featureKey);

export const selectParcelSearchParams = createSelector(selectInputsState, state => state.parcelSearchParams);

export const selectParcelShopSearchParams = createSelector(selectInputsState, state => state.parcelShopSearchParams);

export const selectSelectedCountry = createSelector(selectInputsState, state => state.selectedCountry);

export const selectParcelShopSearchParamsQuery = createSelector(selectParcelShopSearchParams, parcelSearchParams => parcelSearchParams?.query);

export const selectParcelShopSearchParamsFeatures = createSelector(selectParcelShopSearchParams, parcelSearchParams => parcelSearchParams?.features);

export const selectProp = <P extends keyof fromInputs.State>(prop: P, defaultValue?: any) => createSelector(selectInputsState, state => state?.[prop] ?? defaultValue);

export const selectLanguage = createSelector(selectInputsState, state => state.language);
